import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';  
import { Router } from '@angular/router';
import { RegistrationDecodeService } from './registration-decode-service';
import { Loading } from '../loading/loading';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-registration-decode',
  standalone: true,
  imports: [CommonModule, FormsModule, Loading],
  templateUrl: './registration-decode.html',
  styleUrls: ['./registration-decode.scss']
})
export class RegistrationDecode implements OnInit {
  regNo: string = '';
  errorMode = false;
  loading = false;  
  decodeBtnColor: string = '#94A3B8'; 
  fullRegNoLength: number = 10;

  constructor(
    private service: RegistrationDecodeService,
    private router: Router,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.clearLocalStorage();
    // this.clearLocalStorageAll();
  }

  clearLocalStorage() {
    localStorage.removeItem('vehicleData');
    console.log('Local storage cleared');
  }
  clearLocalStorageAll() {
    localStorage.clear();
    console.log('All local storage cleared');
  }

  formatRegNo(regNo: string): string {
    regNo = regNo.toUpperCase().replace(/\s+/g, '');
    return regNo.replace(/^([A-Z]{2})(\d{2})([A-Z]{1,2})(\d{4})$/, '$1 $2 $3 $4');
  }

//   onFileUpload(event: Event) {
//     const input = event.target as HTMLInputElement;
//     if (!input.files?.length) return;

//     const file = input.files[0];
//     this.loading = true;  // 👈 Start loading
//     this.service.parseCarRegisterPlate(file).subscribe({
//       next: (data:any) => {
//         // console.log('Plate API Response:', data);
//         if (data?.code === 200 && data?.data?.registrationNumber &&
//             !data?.data?.description?.includes('Car Details Not Found')) {
//           const rawReg = data.data.registrationNumber.replace(/\s+/g, '');
//           this.regNo = this.formatRegNo(rawReg);
//           console.log("upload-reg",rawReg)
//           this.errorMode = false;
//           localStorage.setItem('vehicleData', JSON.stringify(data.data));
//         } else {
//           this.errorMode = true;
//         }
//         this.loading = false; 
//       },
//       error: (err:any) => {
//         console.error('Upload API Error:', err);
//         this.errorMode = true;
//         this.loading = false; 
//       }
//     });
//   }

  
// onRegNoChange() {
//   // Trim spaces
//   const cleanReg = (this.regNo || '').replace(/\s/g, '');
//  console.log("cleanReg",cleanReg)
//   // 👇 Change color only when full registration number entered
//   if (cleanReg.length >= this.fullRegNoLength) {
//     this.decodeBtnColor = '#144579';
//   } else {
//     this.decodeBtnColor = '#94A3B8';
//   }
// }


onFileUpload(event: Event) {
  const input = event.target as HTMLInputElement;
  if (!input.files?.length) return;

  const file = input.files[0];
  this.loading = true;
  this.service.parseCarRegisterPlate(file).subscribe({
    next: (data: any) => {
      if (
        data?.code === 200 &&
        data?.data?.registrationNumber &&
        !data?.data?.description?.includes('Car Details Not Found')
      ) {
        const rawReg = data.data.registrationNumber.replace(/\s+/g, '');
        this.regNo = this.formatRegNo(rawReg);
        console.log('upload-reg', rawReg);
        this.errorMode = false;
        localStorage.setItem('vehicleData', JSON.stringify(data.data));

        // ✅ Green color for success
        this.decodeBtnColor = '#144579';
      } else {
        this.errorMode = true;

        // ❌ Red color for failure
        this.decodeBtnColor = '#94A3B8';
      }
      this.loading = false;
    },
    error: (err: any) => {
      console.error('Upload API Error:', err);
      this.errorMode = true;
      this.decodeBtnColor = '#94A3B8';
      this.loading = false;
    },
  });
}

onRegNoChange() {
  const cleanReg = (this.regNo || '').replace(/\s/g, '');
  console.log('cleanReg', cleanReg);

  // 👇 Change color only when full registration number entered
  if (cleanReg.length >= this.fullRegNoLength) {
    this.decodeBtnColor = '#144579'; // blue
  } else {
    this.decodeBtnColor = '#94A3B8'; // grey
  }

  // ✅ Reset to normal (no error) when user types again
  this.errorMode = false;
}


  onDecode() {
    if (!this.regNo) {
      // alert('Please enter registration number');
      this.toastr.error("Please enter registration number");
      return;
    }

    this.loading = true;  // 👈 Start loading
    this.service.decodeVehicle(this.regNo).subscribe({
      next: (data:any) => {
        // console.log('Decoded Data:', data);
        if (data.code === 200) {

          this.errorMode = false;
          localStorage.setItem('vehicleData', JSON.stringify(data.data));
          this.router.navigate(['estimate-list']);
        } else {
          this.errorMode = true;
        }
        this.loading = false;  // 👈 Stop loading
      },
      error: (err:any) => {
        console.error('Decode API Error:', err);
        this.errorMode = true;
        this.loading = false;  // 👈 Stop loading
      }
    });
  }

  onTryAgain() {
    this.regNo = '';
    this.errorMode = false;
  }

  goToMake() {
    this.router.navigate(['make']);
  }
}
